import React from 'react';

/**
 * SiteProofLogo — reusable brand component.
 * Props:
 *   size: 'sm' | 'md' | 'lg'  (default: 'md')
 *   iconOnly: boolean — render shield icon only, no wordmark (default: false)
 *   className: extra classes on the wrapper
 */
const sizeConfig = {
  sm: { shield: 28, text: 'text-base', sub: 'text-[10px]', gap: 'gap-1.5' },
  md: { shield: 36, text: 'text-lg', sub: 'text-[11px]', gap: 'gap-2' },
  lg: { shield: 56, text: 'text-3xl', sub: 'text-sm', gap: 'gap-3' },
};

const ShieldCheckIcon = ({ size = 36 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <defs>
      <linearGradient id="shieldGrad" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#22c55e" />
        <stop offset="100%" stopColor="#16a34a" />
      </linearGradient>
    </defs>
    {/* Shield path */}
    <path
      d="M20 2L4 9v12c0 10.5 6.8 20.3 16 23 9.2-2.7 16-12.5 16-23V9L20 2z"
      fill="url(#shieldGrad)"
    />
    {/* Checkmark */}
    <path
      d="M13 22l5 5 9-10"
      stroke="white"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

const SiteProofLogo = ({ size = 'md', iconOnly = false, className = '' }) => {
  const cfg = sizeConfig?.[size] || sizeConfig?.md;

  if (iconOnly) {
    return (
      <span className={`inline-flex items-center justify-center ${className}`}>
        <ShieldCheckIcon size={cfg?.shield} />
      </span>
    );
  }

  return (
    <span className={`inline-flex items-center ${cfg?.gap} ${className}`}>
      <ShieldCheckIcon size={cfg?.shield} />
      <span className="flex flex-col leading-none">
        <span className={`font-bold text-white tracking-tight ${cfg?.text}`}>
          SiteProof
        </span>
      </span>
    </span>
  );
};

export default SiteProofLogo;
export { ShieldCheckIcon };
